import React from "react";
import "./PulsatingSpinner.scss";

interface PulsatingSpinnerProps {
  size?: number;
  color?: string;
  className?: string;
}

export const PulsatingSpinner: React.FC<PulsatingSpinnerProps> = ({
  size = 40,
  color = "#23282c", // Same color used on securitize-id-fe
  //color = whmTheme.palette.primary.main,
  className = "",
}) => {
  return (
    <div
      className={`pulsating-spinner ${className}`}
      style={{
        width: size,
        height: size,
        backgroundColor: color,
      }}
    />
  );
};

export default PulsatingSpinner;
